import { ColumnType, ListingHelper } from 'src/app/core/utils/listing.helper';

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'shared-content-listing',
  templateUrl: './content-listing.component.html',
  styleUrls: ['./content-listing.component.scss'],
  host: { class: 'content-listing' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedContentListingComponent {
  @Input() content!: any;
  @Input() disableProgressLine = false;
  @Input() showProgress = true;
  @Input() showColumnHeaders = true;
  @Input() expandable = true;

  @Input() get showOwner() {
    return this.columnBuilder.isShown('owner');
  }
  set showOwner(value: boolean) {
    this.columnBuilder.setShown('owner', value);
  }

  @Input() get showDate() {
    return this.columnBuilder.isShown('date');
  }
  set showDate(value: boolean) {
    this.columnBuilder.setShown('date', value);
  }

  @Input() get showStatus() {
    return this.columnBuilder.isShown('status');
  }
  set showStatus(value: boolean) {
    this.columnBuilder.setShown('status', value);
  }

  @Input() get showOrganization() {
    return this.columnBuilder.isShown('organization');
  }
  set showOrganization(value: boolean) {
    this.columnBuilder.setShown('organization', value);
  }

  columnBuilder = new ListingHelper();

  constructor() {
    this.columnBuilder.addColumn('image', ColumnTypes.Small, true);
    this.columnBuilder.addDefaultColumn('default');
    this.columnBuilder.addColumn('organization', ColumnTypes.Large);
    this.columnBuilder.addColumn('owner', ColumnTypes.Large);
    this.columnBuilder.addColumn('date', ColumnTypes.Medium);
    this.columnBuilder.addColumn('status', ColumnTypes.Small);
  }
}
class ColumnTypes {
  static readonly Small: ColumnType = new ColumnType(5, 9);
  static readonly Medium: ColumnType = new ColumnType(12, 15);
  static readonly Large: ColumnType = new ColumnType(18, 24);
}
